import { FC, ReactNode } from "react";
import { useController } from "react-hook-form";
import type { UseControllerProps } from "react-hook-form";
import { Flex, LegacyDatePicker, Typography } from "@payping/web-components";
import type { RangePickerProps } from "@payping/web-components/legacyComponents/DatePicker/types";
import { SDKDateObject } from "@payping/utils/dateUtils";

type Props = RangePickerProps<SDKDateObject> &
  UseControllerProps<any> & {
    label?: ReactNode | string;
    labelClassName?: string;
  };

const RHFDateRangePicker: FC<Props> = ({
  name,
  control,
  defaultValue = "",
  rules,
  shouldUnregister,
  label,
  labelClassName,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Flex vertical className="tw:relative tw:pb-[28px]!">
      {label && <Typography.Text className={`tw:mb-[8px]! tw:text-[14px]! ${labelClassName}`}>{label}</Typography.Text>}
      <LegacyDatePicker.RangePicker {...field} {...rest} status={error ? "error" : ""} />
      {error && (
        <Typography.Text type="danger" className="tw:absolute tw:bottom-[2px] tw:start-0">
          {error.message}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default RHFDateRangePicker;
